import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { AdminShell } from './admin/Shell.jsx';
import Login from './admin/Login.jsx';
import Dashboard from './admin/Dashboard.jsx';
import People from './admin/People.jsx';
import Cohorts from './admin/Cohorts.jsx';
import Questionnaires from './admin/Questionnaires.jsx';
import QuestionnaireEditor from './admin/QuestionnaireEditor.jsx';
import Campaigns from './admin/Campaigns.jsx';
import CampaignDetail from './admin/CampaignDetail.jsx';
import Exports from './admin/Exports.jsx';
import Admin from './admin/Admin.jsx';
import Interview from './participant/Interview.jsx';
import Withdraw from './participant/Withdraw.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/i/:token" element={<Interview />} />
        <Route path="/w/:wtoken" element={<Withdraw />} />
        <Route path="/login" element={<Login />} />
        <Route element={<AdminShell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/people" element={<People />} />
          <Route path="/people/:id" element={<People />} />
          <Route path="/cohorts" element={<Cohorts />} />
          <Route path="/cohorts/:id" element={<Cohorts />} />
          <Route path="/questionnaires" element={<Questionnaires />} />
          <Route path="/questionnaires/:id" element={<QuestionnaireEditor />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/campaigns/:id" element={<CampaignDetail />} />
          <Route path="/exports" element={<Exports />} />
          <Route path="/admin" element={<Admin />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
